/* eslint-disable no-unused-vars */
import PropTypes from 'prop-types';

const Resource = ({
    name,
    list = undefined,
    form = undefined,
    routes = [],
    requiresPermission = true,
    visibleWhen = null
}) => null;

export default Resource;
/* eslint-disable no-unused-vars */

Resource.propTypes = {
    /**
     * Type of name
     */
    name: PropTypes.string.isRequired,
    /**
     * Type of list
     */
    list: PropTypes.func,
    /**
     * Type of form
     */
    form: PropTypes.func,
    /**
     * Type of routes
     */
    routes: PropTypes.array,
    /**
     * Type of requiresPermission
     */
    requiresPermission: PropTypes.bool,
    /**
     * Only show this resource when the locale matches the value
     */
    visibleWhen: PropTypes.string
};

Resource.defaultProps = {
    routes: [],
    requiresPermission: true,
    form: undefined,
    list: undefined,
    visibleWhen: null,
};
